import React from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import styles from "./DatePicker.module.scss";
import { cn } from "../../../helpers";
import CalendarDaysIcon from "../../icons/CalendarDays";

export interface CustomDatePickerProps extends ReactDatePickerProps {
    label?: React.ReactNode;
    hasError?: boolean;
    inputSize?: "small";
    errorText?: string;
    errorTextClassName?: string;
    id?: string;
    className?: string;
    wrapperClass?: string;
    calendarClassName?: string;
    iconClassName?: string;
    isRequired?: boolean;
    isOptional?: boolean;
}

export const DatePicker = React.forwardRef<HTMLInputElement, CustomDatePickerProps>(
    (
        {
            label,
            hasError,
            inputSize,
            errorText,
            errorTextClassName,
            id,
            className,
            wrapperClass,
            calendarClassName,
            isRequired,
            isOptional,
            iconClassName,
            ...props
        },
        ref
    ) => {
        return (
            <div
                className={cn(
                    styles.wrapper,
                    label && styles.withLabel,
                    wrapperClass,
                    "v2-datepicker-styles"
                )}
            >
                {label && (
                    <label htmlFor={id} className={styles.label}>
                        {label}
                        {isOptional && (
                            <span className={styles.optional} aria-label="optional">
                                (optional)
                            </span>
                        )}
                        {isRequired && (
                            <span className={styles.required} aria-label="required">
                                *
                            </span>
                        )}
                    </label>
                )}

                <div className={styles.relative}>
                    <ReactDatePicker
                        id={id}
                        className={cn(
                            styles.input,
                            {
                                [styles.error]: hasError,
                                [styles.small]: inputSize === "small",
                            },
                            className
                        )}
                        showPopperArrow={false}
                        calendarClassName={cn(styles.calendar, calendarClassName)}
                        dateFormat="MM/dd/yyyy"
                        dropdownMode="select"
                        placeholderText={props.placeholderText || "MM/DD/YYYY"}
                        {...props}
                    />

                    <CalendarDaysIcon className={cn(styles.icon, iconClassName)} />
                </div>

                {hasError && errorText && (
                    <span className={cn(styles.errorText, errorTextClassName)}>
                        {errorText}
                    </span>
                )}
            </div>
        );
    }
);

DatePicker.displayName = "DatePicker";
